<template>
  <div :class="number % 2 == 0 ? 'Right' : 'Left'">
    <div class="rect" />
    <div class="name_short theme_accent80" v-if="giftRecord">{{ nickName }}</div>
    <div class="name theme_accent80" v-else>{{ nickName }}</div>
    <div class="title theme_white">{{ title }}</div>
    <div class="user">
      <img :src="iconUrl + '/256'" />
    </div>
    <div class="gift" v-if="giftRecord && giftRecord.mostSendGift">
      <img :src="giftRecord.mostSendGift.giftIconUrl" />
      <div class="gift_label">
        <p>x{{ giftRecord.mostSendGift.giftCount }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import * as schema from '../../../api/schema/appGatewayServer'

@Component
export default class CategoryFriendInfo extends Vue {
  @Prop()
  broadcastViewRecord: schema.MemoryAlbumBroadcastViewRecord | undefined

  @Prop()
  giftRecord: schema.MemoryAlbumGiftRecord | undefined

  @Prop()
  collabRecord: schema.MemoryAlbumCollabRecord | undefined

  @Prop()
  chatRecord: schema.MemoryAlbumChatRecords | undefined

  @Prop({ required: true })
  number!: number

  get nickName(): string {
    if (this.broadcastViewRecord) {
      return this.broadcastViewRecord.streamerUser.nickname
    } else if (this.giftRecord) {
      return this.giftRecord.giftReceiver.nickname
    } else if (this.collabRecord) {
      return this.collabRecord.collabUser.nickname
    } else if (this.chatRecord) {
      return this.chatRecord.chatUser.nickname
    }
    return ''
  }

  get iconUrl(): string {
    if (this.broadcastViewRecord) {
      return this.broadcastViewRecord.streamerUser.iconUrl
    } else if (this.giftRecord) {
      return this.giftRecord.giftReceiver.iconUrl
    } else if (this.collabRecord) {
      return this.collabRecord.collabUser.iconUrl
    } else if (this.chatRecord) {
      return this.chatRecord.chatUser.iconUrl
    }
    return ''
  }

  get title(): string {
    if (this.broadcastViewRecord) {
      const hours = this.broadcastViewRecord.totalViewHour.toLocaleString()
      return this.$t('durationFormatHour', { hour: hours }).toString()
    } else if (this.giftRecord) {
      const amount = this.giftRecord.totalGiftSendCount.toLocaleString()
      return this.$tc('memoriesGiftAmount', Number(amount), { gift_amount: amount }).toString()
    } else if (this.collabRecord) {
      const hours = this.collabRecord.totalCollabHour.toLocaleString()
      return this.$t('durationFormatHour', { hour: hours }).toString()
    } else if (this.chatRecord) {
      const count = this.chatRecord.totalChatSendCount.toLocaleString()
      return this.$tc('count', Number(count), { count: count }).toString()
    }
    return ''
  }
}
</script>
<style scoped>
.theme_accent80 {
  color: #C0B6FF;
}

.theme_black {
  color: #262626;
}

.theme_white {
  color: #ffffff;
}

.Right {
  position: relative;
  width: 317px;
  height: 80px;
  font-family: -apple-system, BlinkMacSystemFont;
}

.Right .rect {
  position: absolute;
  width: 237px;
  height: 64px;
  top: 8px;
  left: 54px;

  background: #474951;
}

.Right .name {
  position: absolute;
  max-width: 221px;
  left: 62px;
  top: 36px;

  font-weight: 300;
  font-size: 16px;
  line-height: 24px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.Right .name_short {
  position: absolute;
  max-width: 161px;
  left: 62px;
  top: 36px;

  font-weight: 300;
  font-size: 16px;
  line-height: 24px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.Right .title {
  position: absolute;
  width: 156px;
  left: 62px;
  top: 20px;

  font-weight: 300;
  font-size: 12px;
  line-height: 18px;
}

.Right .user {
  position: absolute;
  left: -26px;
  top: 0px;
  width: 80px;
  height: 80px;

  filter: drop-shadow(0px 0px 4px rgba(100, 100, 100, 0.2));
  background: #ffffff;
}

.Right .gift {
  position: absolute;
  left: 232px;
  top: 12px;
  width: 56px;
  height: 56px;
}

.gift img {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 56px;
  height: 56px;
}

.gift_label {
  position: absolute;
  left: 0px;
  top: 46px;
  width: 56px;
  height: 13px;
}

.gift_label p {
  position: relative;
  height: 13px;
  background: #ffffff;
  border-radius: 2px;
  padding-right: 4px;
  padding-left: 4px;

  font-weight: 300;
  font-size: 11px;
  line-height: 13px;
  align-items: center;
  text-align: center;
}

.user img {
  position: absolute;
  left: 5px;
  top: 5px;
  width: 70px;
  height: 70px;
}

.Left {
  position: relative;
  width: 317px;
  height: 80px;
  font-family: -apple-system, BlinkMacSystemFont;
}

.Left .rect {
  position: absolute;
  width: 237px;
  height: 64px;
  top: 8px;
  left: 0px;

  background: #474951;
}

.Left .name {
  position: absolute;
  max-width: 221px;
  right: 88px;
  top: 36px;

  font-weight: 300;
  font-size: 16px;
  line-height: 24px;

  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.Left .name_short {
  position: absolute;
  max-width: 161px;
  right: 88px;
  top: 36px;

  font-weight: 300;
  font-size: 16px;
  line-height: 24px;

  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.Left .title {
  position: absolute;
  width: 156px;
  right: 88px;
  top: 20px;

  font-weight: 300;
  font-size: 12px;
  line-height: 18px;

  text-align: right;
}

.Left .user {
  position: absolute;
  right: -2px;
  top: 0px;
  width: 80px;
  height: 80px;

  filter: drop-shadow(0px 0px 4px rgba(100, 100, 100, 0.2));
  background: #ffffff;
}

.Left .gift {
  position: absolute;
  left: 2px;
  top: 12px;
  width: 56px;
  height: 56px;
}
</style>
